import { Modal } from "antd";
import type { FC } from "react";

interface JsonViewerModalProps {
  title: string;
  data: unknown;
  onClose: () => void;
}

export const JsonViewerModal: FC<JsonViewerModalProps> = ({ title, data, onClose }) => {
  return (
    <Modal title={title} open={data !== null} onCancel={onClose} footer={null} width={640}>
      <pre style={{ maxHeight: "60vh", overflow: "auto", fontSize: 12 }}>{data === null ? "" : JSON.stringify(data, null, 2)}</pre>
    </Modal>
  );
};
